import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Create Course video content
 * @param course_id
 * @param version
 * @param contentId
 * @param abortController
 */
const createCourseVideoContent = (
  course_id: string,
  version: number,
  contentId: string,
  abortController: AbortController
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/video'
    const data = { contentId }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
      signal: abortController.signal,
    }

    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default createCourseVideoContent
